import { ProcessTemplateDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import {
  ProcessInputFields,
  StepTemplate,
  Template,
  TemplateInputCategory,
} from 'modules/processes/domain/index'

export const useTemplate = (id: string | undefined) => {
  const category = id === 'custom' ? 'default' : id

  const { data, loading } = useQuery(ProcessTemplateDocument, {
    variables: { id: category || '' },
    skip: !id,
  })

  const steps: StepTemplate[] =
    data?.processes.template?.stepObjects?.map((step) => ({
      name: step.name,
      items: step.items.map((item) => ({
        title: item.title,
        configuration_type: item.configurationType || '',
        instruction: item.instruction || '',
        feature: item.feature || '',
        action_configuration_identifier: item.actionConfigurationIdentifier || '',
      })),
    })) ?? []

  const processInputFields: ProcessInputFields[] =
    data?.processes.template?.processInputFieldObjects?.map((field) => ({
      key: field.key,
      data_type: field.dataType || '',
      label: field.label,
      default_value: String(field.default || ''),
      mandatory: field.mandatory,
      custom: field.custom,
    })) ?? []

  const dataCollectionInputCategories: TemplateInputCategory[] =
    data?.processes.template?.dataCollectionInputCategoriesObjects ?? []

  const dataTemplate = data?.processes.template

  const template: Template | undefined = dataTemplate
    ? {
        ...dataTemplate,
        steps: steps,
        processInputFields,
        dataCollectionInputCategories,
      }
    : undefined

  return {
    loading: loading,
    template,
    error: false,
  }
}
